import { memo } from 'react';
import styles from './Advt.module.css';
import { useGetParams } from '../../hooks/useGetParams';
import { AnimatePresence, motion } from 'motion/react';

import logo from '../../assets/images/logo.png';

const Advt = memo(() => {
  const { title, qrCode1, qrCode2, paddingQR, sizeQR, titleFontSize } =
    useGetParams();

  return (
    <div className={styles.wrapper}>
      {/* <img src={logo} alt="logo" className={styles.logo} /> */}

      {title && (
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.8 }}
          className={styles.title}
          style={{ fontSize: `${titleFontSize}rem` }}
        >
          {title}
        </motion.div>
      )}

      <div className={styles.qrsWrapper}>
        {qrCode1 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.1, 1] }}
            transition={{
              scale: { duration: 0.7, delay: 0.25, times: [0, 0.7, 1] },
            }}
            className={styles.qrCode}
            exit={{ opacity: 0, transition: { duration: 0.5, delay: 0 } }}
            style={{
              padding: `${paddingQR}rem`,
              background: paddingQR === '0' && 'none',
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <img src={qrCode1} alt="qrCode1" />
          </motion.div>
        )}
        {qrCode2 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.1, 1] }}
            transition={{
              scale: { duration: 0.7, delay: 0.65, times: [0, 0.7, 1] },
            }}
            exit={{ opacity: 0, transition: { duration: 0.5, delay: 0 } }}
            className={styles.qrCode}
            style={{
              padding: `${paddingQR}rem`,
              background: paddingQR === '0' && 'none',
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <img src={qrCode2} alt="qrCode2" />
          </motion.div>
        )}
      </div>
    </div>
  );
});

export default Advt;
